export class Currency {
  isocode: string;
  amountprecision: string;
  type: string;
}
